import { useNavigate, useRoutes } from 'react-router-dom';
import routes from '../routes/routes';
import { toast, type ToastContent } from 'react-toastify';
// import { logout } from '../services/authService';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const Baselayout = () => {
    const navigate = useNavigate();
    const sidebarRef: any = useRef(null);
    const [isActive, setActive] = useState<boolean>(false);
    let element = useRoutes(routes);
    // const temp = location.pathname.split('/').filter(entry => entry.trim() !== '');
    const loader = useSelector((state: any) => state.counter.loader);
    const showNewPlatfromSign = useSelector((state: any) => state.persistent.showNewPlatfromSign);

    const handleSignout = async () => {
        try {
            // const { result, error } = await logout();
            // if (error || result?.error) {
            //     throw error || result.error;
            // }
            // toast.success(result.message as ToastContent<unknown>, {
            //     style: {
            //         backgroundColor: '#F1F1F1', // Grey background
            //     }
            // });
            navigate('/login');
            localStorage.clear();
        } catch (error: unknown) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    useEffect(() => {
        // Initialize lastActivity on mount if not set
        if (!localStorage.getItem('lastActivity')) {
            localStorage.setItem('lastActivity', String(Date.now()));
        }

        let activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

        const setLastActivity = () => {
            localStorage.setItem('lastActivity', String(Date.now()));
        };

        const activityListener = () => {
            setLastActivity();
        };

        activityEvents.forEach((event) => {
            document.addEventListener(event, activityListener, { passive: true });
        });

        // Check inactivity every 60 seconds instead of every second (more efficient)
        const interval = setInterval(() => {
            const lastActivity = localStorage.getItem('lastActivity');
            if (lastActivity) {
                const diffMs = Math.abs(Date.now() - parseInt(lastActivity));
                const minutes = Math.floor(diffMs / (1000 * 60));
                // Auto-logout after 30 minutes of inactivity (configurable)
                const INACTIVITY_TIMEOUT_MINUTES = 30;
                if (minutes >= INACTIVITY_TIMEOUT_MINUTES) {
                    handleSignout();
                    clearInterval(interval);
                }
            }
        }, 60000); // Check every 60 seconds instead of every second

        return () => {
            activityEvents.forEach((event) => {
                document.removeEventListener(event, activityListener);
            });
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        // Only check for refresh_token if user is logged in
        // If refresh_token is missing but user is logged in, it might be a session issue
        const isLogged = localStorage.getItem('isLogged');
        const refreshToken = localStorage.getItem('refresh_token');
        
        // If user is marked as logged in but refresh_token is missing, clear and redirect
        if (isLogged === 'true' && !refreshToken) {
            console.warn('User is logged in but refresh_token is missing. Clearing session.');
            localStorage.clear();
            navigate("/login");
        }
        // getConversations();
    }, [navigate])

    return (
        <div>
           <div>
           {/* <div className={"admin-body-wrap"}> */}
                {element}
            </div>
            {/* {loader &&
                <Loader />
                // <div className="clip-loader">
                //     <div className="loader-spinner"></div>
                // </div>
            } */}
        </div>
    )
}

export default Baselayout